export const MAKEUP_REQUESTS_NAMESPACE = "makeupRequests";

// Actions
export const ACTIONS = {
  FETCH_REQUESTS: "fetchRequests",
  FETCH_SINGLE_REQUEST: "fetchSingleRequest",
  APPROVE_REQUEST: "approveRequest",
  REJECT_REQUEST: "rejectRequest",
  GET_DOCUMENT: "getDocument",
  GET_CREDIT_ESTIMATE: "getCreditEstimate",
  GET_STAFF_META: "getStaffMeta",
  STAFF_CREATE: "staffCreate",
  GET_APPROVERS: "getApprovers",
  SAVE_APPROVERS: "saveApprovers",
};

// Mutations
export const MUTATIONS = {
  SET_REQUESTS: "setRequests",
  SET_LOADING: "setLoading",
  SET_CURRENT_REQUEST: "setCurrentRequest",
  SET_FILTERS: "setFilters",
  SET_CURRENT_TAB: "setCurrentTab",
  UPDATE_REQUEST_IN_LIST: "updateRequestInList",
};
